export default __webpack_public_path__ + "static/media/successMsg.59a4f8c7.svg";